import { useState } from 'react';
import Helmet from 'react-helmet';
import { Global, css } from '@emotion/react';
import styled from '@emotion/styled';
import Header from '../home/Header';
import MobileNav from '../home/MobileNav';
import Footer from '../home/Footer';
import { colors, layout } from '../home/theme';
import ContactForm from '../contact/ContactForm';

const globalStyles = css`
  body {
    background: ${colors.coreBlue};
    margin: 0;
  }
`;

const Main = styled.main`
  max-width: ${layout.maxWidth};
  margin: 0 auto;
  padding: 64px 24px 96px;

  /* ContactForm's intro paragraph sits directly on this dark navy background
     and needs light text; the same Paragraph component rendered inside the
     light-background form card (a <form>) must keep its own dark text. */
  p:not(form p) {
    color: ${colors.textInverseSecondary};
  }
`;

const SITE_URL = 'https://www.pixels.ai';
const PAGE_URL = `${SITE_URL}/contact/`;
// 1600x900 brand card — the only existing asset in public/ with usable OG dimensions.
const OG_IMAGE = `${SITE_URL}/pixels-logo-blue-bg-16-9.png`;
const TITLE = 'Contact Pixels | Book a Contextual Video Stream Demo';
const DESCRIPTION =
  'Talk to the Pixels team about running the contextual video stream on your inventory. Book a demo to see relevance-matched video across web, app and CTV.';

export default function Contact() {
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  return (
    <>
      <Global styles={globalStyles} />
      <Helmet title={TITLE}>
        <link rel="canonical" href={PAGE_URL} />
        <meta name="description" content={DESCRIPTION} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Pixels" />
        <meta property="og:locale" content="en_GB" />
        <meta property="og:url" content={PAGE_URL} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:image" content={OG_IMAGE} />
        <meta property="og:image:width" content="1600" />
        <meta property="og:image:height" content="900" />
        <meta property="og:image:alt" content="Pixels" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={TITLE} />
        <meta name="twitter:description" content={DESCRIPTION} />
        <meta name="twitter:image" content={OG_IMAGE} />
        <meta name="twitter:image:alt" content="Pixels" />
      </Helmet>
      <Header onMenuClick={() => setMobileNavOpen(true)} />
      <MobileNav open={mobileNavOpen} onClose={() => setMobileNavOpen(false)} />
      <Main>
        <ContactForm legacy />
      </Main>
      <Footer />
    </>
  );
}
